import React, { useState, useEffect, useCallback, useRef } from "react";
import { InfoIconWithMessage } from "../../shared/infoIcon/InfoIcon";
import Grid from "@mui/material/Grid";
import styles from "./AldCupidId.module.scss";
import { withTranslation } from "react-i18next";
import EditIcon from "../../shared/Edit/EditIcon";
import {
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import HasPermissionTo from "../../common/HasPermissionTo";
import MarketPreferencesClient from "../../shared/clients/MarketPreferencesClient";
import PendingActionClient from "../../shared/clients/PendingActionClient";
import { CUPID_ID } from "../../common/Constants";

function AldCupidId(props) {
  const [editMode, setEditMode] = useState(false);
  const [cupidId, setCupidId] = useState(undefined);
  const [cupidIdCopy, setCupidIdCopy] = useState(undefined);
  const [saved, setSaved] = useState(false);

  const aldCupidIdRef = useRef();

  const handleEdit = useCallback(() => {
    setEditMode(true);
    setSaved(false);
  }, []);

  const handleBlur = useCallback((e) => {
    if (e.target.value) {
      if (aldCupidIdRef.current.isValid()) {
        setEditMode(false);
      }
    }
  }, []);

  const handleChange = useCallback((event) => {
    setCupidId(event.target.value);
  }, []);

  const handleSubmit = useCallback(() => {
    props.hideOrShow(true);

    const cupidIdRequest = {
      cupidLeadID: cupidId,
    };

    MarketPreferencesClient.saveCupidIdPreferences(
      props.user,
      cupidIdRequest
    )
      .then(() => {
        PendingActionClient.removeNscPendingAction(
          props.user,
          CUPID_ID,
          2
        );
        setEditMode(false);
        setCupidIdCopy(cupidId);
        setSaved(true);
      })
      .finally(() => props.hideOrShow(false));
  }, [props, cupidId]);

  useEffect(() => {
    props.hideOrShow(true);

    MarketPreferencesClient.getAldCupidId(props.user)
      .then((response) => {
        const aldCupidId = response.result.aldCupidId;
        setCupidId(aldCupidId || "");
        setCupidIdCopy(aldCupidId || "");
      })
      .catch(() => {})
      .finally(() => {
        props.hideOrShow(false);
      });
  }, [props]);

  return (
    <div className="pageWrapper">
      <ValidatorForm onSubmit={handleSubmit}>
        <div className="pagePaddingTop pagePaddingLeft pagePaddingRight">
          <InfoIconWithMessage
            message={props.t("AldCupidId.subheader")}
          />
        </div>

        <div className="pagePaddingTop">
          <Grid container className={styles.divider}>
            <Grid item xs={6}>
              <div className={`${styles.header} ${styles.leftAlignment}`}>
                {props.t("AldCupidId.provider")}
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className={`${styles.header} ${styles.rightAlignment}`}>
                <div>{props.t("AldCupidId.cupidId")}</div>
                <HasPermissionTo
                  perform={["aldCupidId:write"]}
                  permissions={props.user.permissions.rolePermissions}
                  condition={!editMode}
                  render={() => {
                    return (
                      <div className={styles.icon} onClick={handleEdit}>
                        <EditIcon />
                      </div>
                    );
                  }}
                />
              </div>
            </Grid>
          </Grid>

          <Grid container className={styles.rowDivider}>
            <Grid item xs={6}>
              <div className={`${styles.leftAlignment} ${styles.aldCupidId}`}>
                {props.t("AldCupidId.cupidIdRow")}
              </div>
            </Grid>
            <Grid item xs={6}>
              <div
                className={`${styles.rightAlignment} ${styles.textBoxCell}`}
              >
                {editMode ? (
                  <TextValidator
                    onBlur={handleBlur}
                    ref={aldCupidIdRef}
                    data-testid="aldCupidIdInput"
                    id="aldCupidIdInput"
                    name="aldCupidIdInput"
                    className={styles.inputField}
                    variant="outlined"
                    value={cupidId || ""}
                    onChange={handleChange}
                    placeholder="-"
                    validators={["required", "matchRegexp:^[0-9]\\d{10}$"]}
                    errorMessages={[
                      props.t("Error.requiredField"),
                      props.t("AldCupidId.invalidId"),
                    ]}
                  />
                ) : (
                  <div
                    className={styles.cupidIdValue}
                    data-testid="cupidText"
                  >
                    {cupidId}
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
        </div>

        <HasPermissionTo
          perform={["aldCupidId:write"]}
          permissions={props.user.permissions.rolePermissions}
          render={() => {
            return saved ? (
              <div className={styles.saved}>
                {props.t("AldCupidId.saved")}
              </div>
            ) : (
              <div className={styles.applyButton}>
                <button
                  type="submit"
                  data-testid="submitBtn"
                  disabled={cupidId === cupidIdCopy}
                >
                  {props.t("DealerFees.applyButton")}
                </button>
              </div>
            );
          }}
        />
      </ValidatorForm>
    </div>
  );
}

export default withTranslation("emp")(AldCupidId);
